import { z } from 'zod';
export const projectsProjectOrderReferenceCapability = 'projects.project-order-reference.v1';
export const projectsProjectShippingAddressSchema = z.strictObject({
    line1: z.string().trim().min(1).max(240),
    line2: z.string().trim().max(240).nullable(),
    city: z.string().trim().max(120).nullable(),
    region: z.string().trim().max(120).nullable(),
    postalCode: z.string().trim().max(40).nullable(),
    countryCode: z.string().regex(/^[A-Z]{2}$/),
});
export const projectsProjectOrderReferenceSnapshotSchema = z.strictObject({
    contractVersion: z.literal(projectsProjectOrderReferenceCapability),
    projectId: z.string().uuid(),
    label: z.string().trim().min(1).max(500),
    projectRevision: z.number().int().positive(),
    shippingAddress: projectsProjectShippingAddressSchema.nullable(),
});
//# sourceMappingURL=projects-project-order-reference.contract.js.map